import { useEventRefresher, useReadableEventRefresher } from '@zdrbm/zdr-react';
import { IConversationRun } from '../../model/ConversationRun';
import { useCallback } from 'react';
import { useAssistantFacade } from './useAssistantFacade';
import { useConversationRunFeedback } from './useConversationRunFeedback';
import { FeedbackType } from 'features/pi/model/Feedback';

export function useConversationRun(run: IConversationRun) {
    const [[input], [status]] = useReadableEventRefresher(run.input, run.status);
    const facade = useAssistantFacade();

    useEventRefresher(run.responseContainers.itemsAdded);
    useEventRefresher(run.resources.itemChanged);

    const feedbackProps = useConversationRunFeedback(run);

    const sendFeedback = useCallback(
        (type: FeedbackType, content: string = '') => {
            switch (type) {
                case FeedbackType.Positive:
                    facade.sendPositiveRunFeedback(run.conversationId.get(), run.getId(), content);
                    break;
                case FeedbackType.Negative:
                    facade.sendNegativeRunFeedback(run.conversationId.get(), run.getId(), content);
                    break;
                default:
            }
        },
        [facade, run],
    );

    return {
        input,
        status,
        containers: run.responseContainers.getOrderedItems(),
        resources: run.resources.getOrderedItems(),
        sendFeedback,
        ...feedbackProps,
    };
}
